import React from 'react';
import {MasterLayout} from 'components/layouts';
import {PostDemand} from 'components/users';
import MemberZone from './MemberZone.jsx';
import title from 'constants/TitlePages.js';
import _ from 'lodash';

class PostDemandPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    let contentDemandFromProduct = null;
    if (props && props.location && props.location.state && props.location.state.contentDemandFromProduct) {
      contentDemandFromProduct = props.location.state.contentDemandFromProduct;
    }
    this.state = {
      contentDemandFromProduct
    }
  }

  componentDidMount() {
    document.title = title.PostDemandPage;
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.location &&
      nextProps.location.state &&
      nextProps.location.state.contentDemandFromProduct &&
      !_.isEqual(nextProps.location.state.contentDemandFromProduct, this.state.contentDemandFromProduct)
    ) {
      contentDemandFromProduct = nextProps.location.state.contentDemandFromProduct;
    }
  }

  render() {
    return (
      <MasterLayout>
        <PostDemand contentDemandFromProduct={this.state.contentDemandFromProduct}/>
      </MasterLayout>
    );
  }
}

export default MemberZone(PostDemandPage);


// WEBPACK FOOTER //
// ./pages/users/PostDemandPage.jsx